import { Api } from "./Api";

export default {
    index() {
        return Api.get(`/v1/management/users`);
    },
    show(user_id) {
        return Api.get(`/v1/management/users/${user_id}`);
    },
    update(user_id, obj) {
        return Api.put(`/v1/management/users/${user_id}`, obj);
    },
}